import React from "react";
import Button from "react-bootstrap/Button";
import Popover from "react-bootstrap/Popover";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { CirclePicker } from "react-color";

/**
 * ColorPicker control, takes props
 * @param     {color}     color
 * @param     {function}  onChange(newColor)
 * @constructor
 */
function ColorPicker(props) {
  const popoverColor = (
    <Popover>
      <Popover.Content>
        <CirclePicker
          circleSize={23}
          circleSpacing={6}
          width={205}
          colors={props.colors}
          color={props.color}
          onChangeComplete={props.onChange}
        />
      </Popover.Content>
    </Popover>
  );
  return (
    <OverlayTrigger
      trigger="click"
      placement="bottom"
      overlay={popoverColor}
      rootClose={true}
    >
      <Button
        variant="square"
        {...props}
        style={{
          ...props,
          backgroundColor: props.color,
          borderColor: props.color
        }}
      />
    </OverlayTrigger>
  );
}

export default ColorPicker;
